import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "ea2ff622-78ca-4410-af6e-d01abce6f362",
    options: { imageUrl: `${config.ASSETS_URL}/01/15/task/task-01-item-01.png` },
  },
  {
    id: "1fe2ca6b-66ba-4212-8870-0f6a893b5a3b",
    options: { imageUrl: `${config.ASSETS_URL}/01/15/task/task-01-item-02.png` },
  },
  {
    id: "38544ac3-2537-4854-a41a-e16d86c0266e",
    options: { imageUrl: `${config.ASSETS_URL}/01/15/task/task-01-item-03.png` },
  },
  {
    id: "14e043d5-3f46-43e4-b93d-81f1a8d074b2",
    options: { imageUrl: `${config.ASSETS_URL}/01/15/task/task-01-item-04.png` },
  },
  {
    id: "cfd54824-3dbd-4f82-ba3c-0b9e01031ab1",
    options: { imageUrl: `${config.ASSETS_URL}/01/15/task/task-01-item-05.png` },
  },
  {
    id: "ac36f712-8772-40a9-b28d-71fb79580dcc",
    options: { imageUrl: `${config.ASSETS_URL}/01/15/task/task-01-item-06.png` },
  },
  {
    id: "07eb20b9-5837-4abb-b6ed-ebb3b4ed3f22",
    options: { imageUrl: `${config.ASSETS_URL}/01/15/task/task-01-item-07.png` },
  },
  {
    id: "ac5bec24-1ab4-43c5-b9fa-064873de3565",
    options: { imageUrl: `${config.ASSETS_URL}/01/15/task/task-01-item-08.png` },
  },
];

const groups = [
  { id: "297988e4-835d-4665-adb3-2e292acf19e0", content: "MONOPOLE", options: {} },
  { id: "8ddf89a0-65ce-4e62-bb97-de420e1ef2a7", content: "DIPOLE", options: {} },
  { id: "d286c9aa-de6a-40a7-b3df-8103c7bc51bb", content: "QUADRUPOLE", options: {} },
];

export const task: Task = {
  id: "15969efb-b3e3-4722-8adb-89f22701300c",
  solutionType: "group",
  type: "categorizeImages",
  options: {
    orientation: "vertical",
    shuffle: true,
    sectionItemsAmount: 2,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "297988e4-835d-4665-adb3-2e292acf19e0",
      itemsId: ["ea2ff622-78ca-4410-af6e-d01abce6f362", "38544ac3-2537-4854-a41a-e16d86c0266e"],
    },
    {
      groupId: "8ddf89a0-65ce-4e62-bb97-de420e1ef2a7",
      itemsId: [
        "14e043d5-3f46-43e4-b93d-81f1a8d074b2",
        "cfd54824-3dbd-4f82-ba3c-0b9e01031ab1",
        "ac5bec24-1ab4-43c5-b9fa-064873de3565",
      ],
    },
    {
      groupId: "d286c9aa-de6a-40a7-b3df-8103c7bc51bb",
      itemsId: [
        "1fe2ca6b-66ba-4212-8870-0f6a893b5a3b",
        "ac36f712-8772-40a9-b28d-71fb79580dcc",
        "07eb20b9-5837-4abb-b6ed-ebb3b4ed3f22",
      ],
    },
  ],
};
